/** @jsx jsx */
import { gql } from '@apollo/client';
import { Col, Container, Row } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import BrandLogo, { BrandLogoFragments } from '../Brand/BrandLogo';
import ExhibitorHeader, {
  ExhibitorHeaderFragment,
} from '../Exhibitor/ExhibitorHeader';
import ChangeExhibitorLink from './ChangeExhibitorLink';
import { graphql } from 'gatsby';

export default function ExhibitorHeaderRow({
  exhibitor,
  previous,
  next,
  getExhibitorPath,
}) {
  return (
    <Container>
      <Row sx={{ justifyContent: 'center' }}>
        <Col sx={{ marginTop: [-75, -50] }}>
          <BrandLogo size="large" brand={exhibitor} />
        </Col>
        <Col
          sx={{
            paddingY: 4,
            flex: '1',
            minWidth: ['100%', 'unset'],
            order: [1, 'unset'],
          }}
        >
          <ExhibitorHeader as="h1" exhibitor={exhibitor} gutter={3} />
        </Col>
        <Col sx={{ order: -1, minWidth: `${100 / 12}%`, textAlign: 'right' }}>
          <ChangeExhibitorLink
            exhibitor={previous}
            to={getExhibitorPath(previous?.slug)}
            direction="previous"
            sx={{ marginLeft: -4, marginRight: -3, marginTop: 3 }}
          />
        </Col>
        <Col sx={{ minWidth: `${100 / 12}%` }}>
          <ChangeExhibitorLink
            exhibitor={next}
            to={getExhibitorPath(next?.slug)}
            sx={{ marginLeft: -3, marginRight: -4, marginTop: 3 }}
          />
        </Col>
      </Row>
    </Container>
  );
}

export const fragment = graphql`
  fragment ExhibitorHeaderRow on Exhibitor {
    ...BrandLogoLarge
    ...ExhibitorHeader
  }
`;

export const ExhibitorHeaderRowFragment = gql`
  ${BrandLogoFragments.large}
  ${ExhibitorHeaderFragment}
  fragment ExhibitorHeaderRow on Exhibitor {
    ...BrandLogoLarge
    ...ExhibitorHeader
  }
`;
